function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => React.createElement("svg", _extends({
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 84 94"
}, props), React.createElement("path", {
  d: "M24.78 50.826c-5.173-5.473-8.07-9.458-10.202-12.892-2.98-4.81-3.048-10.516-.302-15.425L23.243 6.5M59.33 57.329L81 80.13 64.023 91.993 44.838 71.865",
  stroke: "#357287",
  strokeWidth: "3",
  strokeMiterlimit: "10",
  strokeLinecap: "round"
}), React.createElement("path", {
  d: "M60.757 6.507l8.967 16.01c2.745 4.901 2.67 10.614-.302 15.424-2.334 3.766-6.104 8.731-12.183 14.959L19.977 92 3 80.137l38.589-40.602C56.618 24.033 60.538 14.54 61.252 9.398c.403-2.891-1.83-5.564-5.197-6.241C53.15 2.57 48.952 2 43.612 2h-3.216c-5.34 0-9.538.571-12.443 1.157-3.367.677-5.6 3.35-5.197 6.241.672 4.817 3.375 12.604 16.154 26.413",
  stroke: "#357287",
  strokeWidth: "3",
  strokeMiterlimit: "10",
  strokeLinecap: "round"
}), React.createElement("path", {
  d: "M23.62 65.214L10.01 79.53l9.237 6.453 18.89-19.825c-5.314.345-10.26-.134-14.516-.945z",
  fill: "#C0D2D6"
}), React.createElement("path", {
  d: "M57.23 19.815S49.104 18.701 42 18.701s-15.23 1.114-15.23 1.114",
  stroke: "#357287",
  strokeWidth: "3",
  strokeMiterlimit: "10",
  strokeLinecap: "round"
})));